// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';

export const RunOut = zod.object({
  "cost_usd": zod.string(),
  "created_at": zod.iso.datetime({"offset":true}),
  "error": zod.union([zod.string(),zod.null()]),
  "id": zod.uuid(),
  "latency_ms": zod.union([zod.int(),zod.null()]),
  "model_key": zod.union([zod.string(),zod.null()]),
  "model_name": zod.union([zod.string(),zod.null()]),
  "process_key": zod.string(),
  "status": zod.string(),
  "subject_id": zod.union([zod.string(),zod.null()]),
  "subject_type": zod.union([zod.string(),zod.null()]),
  "tokens_cache_read": zod.int(),
  "tokens_cache_write": zod.int(),
  "tokens_input": zod.int(),
  "tokens_output": zod.int(),
  "tool_calls": zod.int(),
  "turns": zod.int(),
  "user_name": zod.union([zod.string(),zod.null()])
});

export type RunOut = zod.input<typeof RunOut>;
export type RunOutOutput = zod.output<typeof RunOut>;
